module.exports = __webpack_public_path__ + "img/road.26b0d5cd.jpg";